import { render, staticRenderFns } from "./MaterialSales.vue?vue&type=template&id=4a42aeca&scoped=true"
import script from "./MaterialSales.vue?vue&type=script&lang=js"
export * from "./MaterialSales.vue?vue&type=script&lang=js"
import style0 from "./MaterialSales.vue?vue&type=style&index=0&id=4a42aeca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a42aeca",
  null
  
)

export default component.exports